import React from 'react'
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  ClickAwayListener,
  Popover,
} from '@mui/material'
import {
  getStandardsForFilters,
  IdType,
  useGetStandardsById,
} from 'reducers/standards_hooks'
import { Standard } from 'shared/types'

import { ConfirmCommitButton } from 'shared/ui'

export function StandardRetriever({
  currentStandardIds,
  onStandardSelect,
  onStandardDelete,
}: {
  currentStandardIds: IdType[]
  onStandardSelect: (s: Standard) => void
  onStandardDelete: (s: Standard) => void
}) {
  const [adding, setAdding] = React.useState(false)
  const { missing, standards } = useGetStandardsById(...currentStandardIds)
  const onSelect = (s: Standard) => {
    onStandardSelect(s)
    setAdding(false)
  }

  return (
    <Box>
      <Box display={'flex'}>
        {standards.map((s, i) => (
          <Box
            border={'1px solid'}
            marginRight={'2px'}
            padding={'3px'}
            borderRadius={'5px'}
            key={i}
          >
            {s.standardName}
            <ConfirmCommitButton onClick={() => onStandardDelete(s)}>
              <>X</>
            </ConfirmCommitButton>
          </Box>
        ))}
      </Box>
      <Box>
        <Button
          size="small"
          variant="outlined"
          onClick={() => setAdding(!adding)}
        >
          {adding ? 'x' : '+'}
        </Button>
        {adding && <AddStandard onStandardSelect={onSelect} />}
      </Box>
      {!!missing.length && (
        <Box>{`Couldn't retrieve ${missing.join(', ')}`}</Box>
      )}
    </Box>
  )
}

function AddStandard({
  onStandardSelect,
}: {
  onStandardSelect: (s: Standard) => void
}) {
  const [standardName, setStandardName] = React.useState('')
  const [state, setState] = React.useState('FL')
  const [foundStandards, setFoundStandards] = React.useState<Standard[]>([])
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const filters = () => {
    return {
      standard_name: standardName,
      state,
    }
  }
  function findClicked(e: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(e.currentTarget)
    getStandardsForFilters(filters()).then(setFoundStandards)
  }

  function standardSelected(s: Standard) {
    onStandardSelect(s)
    setStandardName('')
    setFoundStandards([])
  }

  return (
    <Box>
      <TextField
        value={standardName}
        onChange={(e) => setStandardName(e.target.value)}
      />
      <Select<string>
        value={state}
        style={{ border: 'solid 1px' }}
        onChange={(e) => setState(e.target.value)}
      >
        <MenuItem value={''}>All</MenuItem>
        <MenuItem value={'FL'}>FL</MenuItem>
      </Select>
      <ClickAwayListener onClickAway={() => setFoundStandards([])}>
        <Button size="small" variant="outlined" onClick={findClicked}>
          Find
        </Button>
      </ClickAwayListener>
      <Popover open={!!foundStandards.length} anchorEl={anchorEl}>
        <>
          {foundStandards.map((s) => (
            <Box key={s.standardId}>
              <Button onClick={() => standardSelected(s)}>
                {s.standardName}
              </Button>
            </Box>
          ))}
        </>
      </Popover>
    </Box>
  )
}
